exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mirror[data-v-25892252] {\n  transform: scaleX(-1);\n}\n", ""]);

// exports
